import { capitalize } from 'lodash';
import { QLog, QTask } from '@qwealth/qdata';
import { ACTIVITY_TYPE_EVENTS, ACTIVITY_TYPE_LOGS, ACTIVITY_TYPE_TASKS, ActivityType } from 'data/models/Activity';

interface Props {
  type: ActivityType;
  initialEventValues?: any;
  initialTaskValues: Partial<QTask> | null;
  initialLogValues: Partial<QLog> | null;
}

export const getTitle = ({ type, initialEventValues, initialTaskValues, initialLogValues }: Props): string => {
  let title: string = capitalize(type);

  switch (type) {
    case ACTIVITY_TYPE_LOGS:
      title = initialLogValues?.uuid ? `Call ${title}` : `Add Call ${title}`;
      break;
    case ACTIVITY_TYPE_EVENTS:
      title = initialEventValues?.id ? title : `Add ${title}`;
      break;
    case ACTIVITY_TYPE_TASKS:
      title = initialTaskValues?.id ? title : `Add ${title}`;
      break;
    default:
      break;
  }

  return title;
};
